import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import AboutHero from "@/components/AboutHero";
import OurStory from "@/components/OurStory";
import TeamSection from "@/components/TeamSection";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | AI-labbet</title>
        <meta name="description" content="Learn about AI-labbet's mission to help organizations navigate AI transformation with strategy, governance, and education." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="About" />
        <main>
          <AboutHero />
          <OurStory />
          <TeamSection />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;
